module.exports = __webpack_public_path__ + "img/77295.e943ee7d.svg";